import React from 'react';

import { ProfileLayout } from '../../components/profile/layout';
import { AccountSettings } from '../../components/profile/account-settings';
import { getNav } from '../../lib/get-nav';
import { initializeApollo } from '../../lib/auth/apollo';

export async function getStaticProps() {
  const apolloClient = initializeApollo();

  await getNav(apolloClient);

  return {
    props: {
      initialApolloState: apolloClient.cache.extract(),
    },
    revalidate: 100,
  };
}

const Profile = () => {
  return (
    <ProfileLayout pageTitle="Account Settings">
      <AccountSettings />
    </ProfileLayout>
  );
};

export default Profile;
